import { Icon } from '@design';
import React, { forwardRef, ReactNode } from 'react';

import styles from './DocumentViewerContainer.module.scss';

interface DocumentViewerContainerProps {
  name: string;
  iconNode?: ReactNode;
  children: ReactNode;
  onClick: () => void;
  showHeader?: boolean;
}

export const DocumentViewerContainer = forwardRef<
  HTMLDivElement,
  DocumentViewerContainerProps
>(({ children, name, iconNode, onClick, showHeader = true }, ref) => {
  return (
    <div className={styles.container} ref={ref}>
      {showHeader && (
        <div className={styles.header}>
          <div className={styles.leftContainer}>
            <div onClick={onClick}>
              {iconNode}
              {name}
              <Icon iconName="ExternalLink" size={20} aria-hidden="true" />
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
});
